export default "__VITE_ASSET__C4u4WgK7__"